module.exports = __webpack_public_path__ + "static/img/zhengce.93423eb6.png";